export default {
  requestHelper: {
    errors: {
      timeout: 'Délai d\'attente dépassé',
      unauthorized: 'Accès non autorisé',
      other: 'Erreur de récupération des données',
    },
  },
};
